<template>
  <div class="content">
    <div
      style="
        margin-top: 12px;
        display: grid;
        padding: 0 3%;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
      "
    >
      <div
        v-for="(item, index) in lotTabList"
        :key="index"
        class="t-c"
        @click="getLotC(index)"
      >
        <p
          style="
            border-radius: 10px;
            background: #ffffff;
            box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
            width: 43px;
            height: 43px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          "
          :class="{ 'active-lotL': index === selectLotIndex }"
        >
          <img
            v-if="index === 0"
            :src="
              selectLotIndex === 0
                ? require('@/assets/img/lottery/xxx_lot7.png')
                : item.img
            "
            width="25"
          />
          <img v-else :src="item.img" width="25" />
        </p>
        <p class="m-t-5" style="font-size: var(--vk-fs-xs)">{{ item.name }}</p>
      </div>
    </div>

    <div class="lottery-tab2--c">
      <div v-if="selectLotIndex !== 1">
        <div>
          <div class="d-flex m-b-10">
            <img src="../../assets/img/lottery/xxx_lot2.png" width="22" />
            <p class="m-l-5 f-t-15 f-w">{{ $lang.common_txt168 }}</p>
          </div>
        </div>
        <div class="d-flex-s" style="flex-flow: row wrap">
          <div
            v-for="(item, index) in lotList2"
            :key="index"
            style="width: 49%; margin-bottom: 5px; position: relative"
            @click="goToDetail(item)"
          >
            <img :src="item.iconUrl" width="100%" height="100" />
            <p
              style="
                position: absolute;
                left: 10px;
                bottom: 12px;
                background: #ffe416;
                padding: 2px 10px;
                border-radius: 15px;
              "
            >
              {{ getIssueNo(item) }}
            </p>
            <p
              style="
                position: absolute;
                right: 10px;
                bottom: 8px;
                background: #3979e3;
                font-size: var(--vk-fs-15);
                font-weight: bold;
                color: #ffffff;
                padding: 3px 5px;
                border-radius: 15px;
              "
            >
              {{ item.countdown || '00:00' }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="[0, 1].includes(selectLotIndex)">
        <div class="d-flex m-b-10">
          <img src="../../assets/img/lottery/xx_lot.png" width="20" />
          <p class="m-l-5 f-t-15 f-w">{{ $lang.common_txt169 }}</p>
        </div>
        <div>
          <div
            class="lottery-tab2--bg"
            v-for="(item3, index3) in lotList"
            :key="index3"
            @click="goToDetail(item3)"
          >
            <img
              :src="
                require(`@/assets/img/lottery/game_bg${(index3 % 3) + 1}.png`)
              "
              width="100%"
              style="min-height: 125px"
            />
            <div
              style="
                position: absolute;
                left: 170px;
                top: 35px;
                color: #ffffff;
                font-size: var(--vk-fs-lg);
                font-weight: bold;
              "
            >
              {{ jackpotText(item3) }}
            </div>
            <div class="lottery-tab2--i2-x">
              <div class="lottery-tab2--i2">
                {{ item3.countdown || '00:00' }}
              </div>
            </div>
            <img class="lottery-tab2--i8" :src="item3.iconUrl" />
          </div>
        </div>
      </div>
    </div>
    <p class="m-l-20 f-t-15 f-w">{{ $lang.common_txt171 }}</p>
    <p class="m-l-20 m-t-5 m-b-10">{{ $lang.common_txt172 }}</p>
    <div v-if="pList.length > 0" class="jack-bg">
      <div style="width: 90%; margin: 0 auto; text-align: center">
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <div
            style="
              background: #1f2a47;
              border-radius: 8px;
              width: 38px;
              height: 38px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 22px;
            "
          >
            <img src="../../assets/img/lottery/lot_jb.png" width="22" />
          </div>
        </div>
        <p
          style="
            color: #1f2a47;
            font-weight: 800;
            margin: 5px 0;
            font-size: var(--vk-fs-15);
          "
        >
          {{ $lang.common_txt173 }}
        </p>
        <div
          style="display: flex; justify-content: center; align-items: center"
        >
          <div
            style="
              border: 1px solid #ffffff;
              border-radius: 15px;
              background: #1f2a47;
              color: #ffffff;
              font-size: var(--vk-fs-xl);
              padding: 10px 0;
              width: 260px;
              text-align: center;
            "
          >
            <span style="font-size: var(--vk-fs-sm)">{{ getCurrency }} </span
            >{{ getToalMout() }}
          </div>
        </div>
      </div>

      <div class="m-t-20" style="padding: 0 7px">
        <div
          style="color: #ffffff; justify-content: space-between"
          class="d-flex"
        >
          <p class="d-flex" style="width: 40%; padding-left: 30px">
            <img
              src="../../assets/img/lottery/lot_x1.png"
              width="12"
              class="m-r-5"
            />
            <span>{{ $lang.common_txt174 }}</span>
          </p>
          <p class="d-flex" style="width: 32%">
            <img
              src="../../assets/img/lottery/lot_x2.png"
              width="12"
              class="m-r-5"
            />
            <span>{{ $lang.common_txt175 }}</span>
          </p>
          <p class="d-flex" style="width: 28%">
            <img
              src="../../assets/img/lottery/lot_x3.png"
              width="12"
              class="m-r-5"
            />
            <span>{{ $lang.common_txt176 }}</span>
          </p>
        </div>
        <div style="height: 210px; overflow: hidden; margin-top: 5px">
          <div
            class="scroll-list"
            ref="scrollList"
            :style="{ transform: `translateY(${scrollTop}px)` }"
          >
            <div
              v-for="(item, index) in fullList"
              :key="index"
              class="d-flex-s"
              style="
                background: #ffffff;
                margin-bottom: 8px;
                border-radius: 8px;
                padding: 5px 15px 5px 5px;
                border: 1px solid;
                color: #43324d;
                font-size: var(--vk-fs-sm);
                font-weight: bold;
                text-align: left;
              "
              @click="goToTyepe(item)"
            >
              <p class="d-flex" style="width: 40%">
                <img
                  :src="
                    require(`@/assets/img/avatar/avatar_${getFixedAvatarIndex(
                      item,
                      index
                    )}.jpg`)
                  "
                  width="20"
                  style="border-radius: 50%; margin-right: 5px"
                />
                <span>{{ item.userName }}</span>
              </p>
              <p style="width: 35%">{{ item.gameName }}</p>
              <p style="width: 25%">
                {{ getCurrency }} {{ $formatNumberWithCommas(item.amount) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 93%; margin: 20px auto">
      <p class="f-t-15 f-w m-b-10">{{ $lang.common_txt177 }}</p>
      <div
        class="lot-reslut"
        v-for="(item, index) in lotResultList"
        :key="index"
      >
        <div class="d-flex-s">
          <div class="d-flex">
            <img :src="item.iconUrl" width="40" />
            <p class="m-r-5 m-l-5 f-t-15" style="font-weight: bold">
              {{ item.lotteryName }}
            </p>
            <p v-if="isCryptoLottery(item.lotteryType)">
              ({{ getIssueNo(item) }})
            </p>
            <p v-else>({{ getResultDate(item) }})</p>
          </div>
          <div
            @click="goToDetail(item)"
            class="d-flex"
            style="color: #c83535"
          >
            <p>{{ $lang.common_txt178 }}</p>
            <van-icon name="arrow" />
          </div>
        </div>
        <p
          style="
            height: 1px;
            background: #c9c9c9;
            margin-bottom: 10px;
            margin-top: 5px;
          "
        ></p>
        <div>
          <div
            v-if="isCryptoLottery(item.lotteryType)"
            class="d-flex"
            style="flex-flow: wrap row"
          >
            <p
              class="lot-ball"
              v-for="(item2, index2) in splitResult(item.lotteryResult)"
              :key="index2"
            >
              {{ item2 }}
            </p>
            <p
              style="
                background: #ffeb00;
                color: #1f2a47;
                height: 30px;
                width: 70px;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                margin-left: 20px;
                margin-bottom: 5px;
              "
              @click="goToBin(item.resultBasedOn)"
            >
              {{ $lang.common_txt181 }}
            </p>
          </div>
          <div v-else>
            <div>
              <p class="f-t-15 f-w m-b-5">winning:</p>
              <div class="d-flex" style="flex-flow: wrap row">
                <p
                  class="lot-ball"
                  v-for="(item2, index) in getResultBalls(item, 'winning')"
                  :key="index"
                >
                  {{ item2 }}
                </p>
              </div>
            </div>
            <div v-if="hasResultMachine(item)">
              <p class="f-t-15 f-w m-b-5 m-t-5">machine:</p>
              <div class="d-flex" style="flex-flow: wrap row">
                <p
                  class="lot-ball"
                  v-for="(item2, index) in getResultBalls(item, 'machine')"
                  :key="index"
                >
                  {{ item2 }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!isCryptoLottery(item.lotteryType)"
        >
          <p class="m-t-10 m-b-10" style="font-weight: 800">
            {{ $lang.common_txt176 }}
          </p>
          <p style="font-size: var(--vk-fs-xl); font-weight: bold">
            {{ jackpotText(item) }}
          </p>
        </div>
        <div
          style="
            margin-top: 10px;
            border: 1px solid #0074bf;
            border-radius: 20px;
            width: 220px;
            padding: 10px 0;
            text-align: center;
            font-weight: 800;
            color: #0074bf;
          "
          @click="goToDetail3(item.lotteryType, item.lotteryName)"
        >
          {{ $lang.common_txt184 }}
        </div>
      </div>
    </div>

    <div class="content-bbttom" style="padding: 20px 0 50px">
      <div style="width: 90%; margin: 0 auto">
        <img src="../../assets/img/common/logo_h.png" width="100" />
        <p class="m-t-10">
          {{ $lang.common_txt164 }}
        </p>

        <!-- <p class="content-line m-t-10"></p> -->
        <!-- <img src="../../assets/img/common/cmc_1.png" width="90%" /> -->
        <p class="content-line m-t-10"></p>
        <p class="m-t-20">{{ $lang.common_txt165 }}</p>
        <img
          class="m-t-10"
          src="../../assets/img/common/cmc_2.png"
          width="90%"
        />
        <p class="content-line m-t-10"></p>
        <img
          class="m-t-10"
          src="../../assets/img/common/cmc_3.png"
          width="100%"
        />
        <p class="content-line m-t-10"></p>
        <div class="t-c">
          <p style="font-weight: 800">{{ $lang.common_txt166 }}</p>
          <p>{{ $lang.common_txt167 }}</p>
        </div>
      </div>
    </div>
    <login v-model="showPopup3" overlay></login>
  </div>
</template>
<script>
import {
  MainInit,
  GetLotteryLatestResults,
  GetServerDateTime,
  GetHomeWinningLottoList,
  FreshIssueInfo
} from '@/api/common'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import {
  filterPlayableLotteryEntries as filterPlayableLotteryCatalogEntries,
  filterLotteryByTab,
  isCryptoLotteryType,
  lotteryJackpotMillion
} from './lotteryCatalog'
import { SINGLE_COUNTRY } from '@/config/singleCountry'

// 全部 6 个彩种 tab(前 3 = CIV 现金彩,后 3 = 加密彩 TRON/ETH/BNB)。
// lang 依赖故用函数形式,在 data() 内传入 this.$lang 求值。
// 单国下只取前 3(现金彩);多国扩展时 SINGLE_COUNTRY 置 null 自动恢复全 6 tab。
function LOT_TABS_ALL(lang) {
  return [
    {
      img: require('@/assets/img/lottery/xxx_lot6.png'),
      name: lang.common_txt189
    },
    {
      img: require('@/assets/img/lottery/xx_lot.png'),
      name: lang.common_txt190
    },
    {
      img: require('@/assets/img/lottery/xxx_lot2.png'),
      name: lang.common_txt191
    },
    {
      img: require('@/assets/img/lottery/xxx_lot3.png'),
      name: 'TRON'
    },
    {
      img: require('@/assets/img/lottery/xxx_lot4.png'),
      name: 'ETH'
    },
    {
      img: require('@/assets/img/lottery/xxx_lot5.png'),
      name: 'BNB'
    }
  ]
}

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}
import { openExternalUrl } from './safeLayout'
import { isLaunchUnavailableToken } from '@/components/home/gameLaunch'
import {
  isLotteryNeedLoginResponse,
  isLotteryOkResponse,
  isLotteryReadOnlyQueryResponse,
  isLotteryReadableResponse,
  lotteryResponseBody,
  lotteryResponseMessage
} from '../details/lottery/lotteryResponse'
export default {
  name: 'Lottery',
  data() {
    return {
      lotTabList: SINGLE_COUNTRY
        ? LOT_TABS_ALL(this.$lang).slice(0, 3)
        : LOT_TABS_ALL(this.$lang),
      scrollTop: 0,
      timer2: null,
      itemHeight: 32,
      memberList: [
        this.$lang.common_txt99,
        this.$lang.common_txt100,
        this.$lang.common_txt101,
        this.$lang.common_txt102,
        this.$lang.common_txt103,
        this.$lang.common_txt104,
        this.$lang.common_txt105,
        this.$lang.common_txt106,
        this.$lang.common_txt107,
        this.$lang.common_txt108,
        this.$lang.common_txt109,
        this.$lang.common_txt110
      ],
      MenList: [
        {
          img: require('@/assets/img/home/men_1.png'),
          name: this.$lang.common_txt138
        },
        {
          img: require('@/assets/img/home/men_2.png'),
          name: this.$lang.common_txt139
        }
      ],
      ListLot: [
        {
          img: require('@/assets/img/lottery/lot_ico1.png'),
          cot1: this.$lang.common_txt149,
          cot2: this.$lang.common_txt150
        },
        {
          img: require('@/assets/img/lottery/lot_ico2.png'),
          cot1: this.$lang.common_txt151,
          cot2: this.$lang.common_txt152
        },
        {
          img: require('@/assets/img/lottery/lot_ico3.png'),
          cot1: this.$lang.common_txt153,
          cot2: this.$lang.common_txt154
        }
      ],
      gameValue: '',
      showPopup3: false,
      pList: [],
      dayList: [
        { id: 7, name: 'Sun' },
        { id: 1, name: 'Mon' },
        { id: 2, name: 'Tue' },
        { id: 3, name: 'Wed' },
        { id: 4, name: 'Thu' },
        { id: 5, name: 'Fri' },
        { id: 6, name: 'Sat' }
      ],
      SelectiTab: 0,
      SelectiTab2: 0,
      selectMenIndex: 0,
      lotList: [],
      lotList2: [],
      copyLotList2: [],
      tabList: [
        { icon: require('@/assets/img/lottery/tab4.png') },
        { icon: require('@/assets/img/lottery/tab1.png') },
        { icon: require('@/assets/img/lottery/tab2.png') },
        { icon: require('@/assets/img/lottery/tab3.png') }
      ],
      timer: null,
      lastList: [],
      lotResultList: [],
      readOnlyQuery: false,
      dateStr: null, // 服务器时间戳（毫秒）
      globalTimer: null, // 全局定时器
      refreshing: new Map(), // 存储正在刷新的彩票类型（key: lotteryType, value: boolean）
      selectLotIndex: 0,
      hsTime2: null
    }
  },
  computed: {
    fullList() {
      return this.pList.length ? this.pList.concat(this.pList[0]) : []
    }
  },
  async mounted() {
    await this.GetServerDateTime()
    await this.MainInit()
    this.GetHomeWinningLottoList()
    this.GetDrawHistory()
    this.startScroll()
    this.startGlobalTimer()
  },
  beforeDestroy() {
    this.stopScroll()
    if (this.globalTimer) {
      clearInterval(this.globalTimer)
      this.globalTimer = null
    }
  },
  methods: {
    safeList(list) {
      return Array.isArray(list) ? list : []
    },
    safeNumber(value) {
      const num = Number(value)
      return Number.isFinite(num) ? num : 0
    },
    firstValue(...values) {
      const hit = values.find((value) => value !== undefined && value !== null && value !== '')
      return hit === undefined ? '' : hit
    },
    responseBody(data) {
      return lotteryResponseBody(data)
    },
    lotteryMarkerToken(value) {
      return String(value == null ? '' : value).trim().toLowerCase()
    },
    isLocalLotteryUnavailableToken(value) {
      const token = this.lotteryMarkerToken(value)
      return !!token && (
        token.includes('技术错误') ||
        token.includes('技术异常') ||
        token.includes('technical_error') ||
        token.includes('technical-error') ||
        token.includes('technical error') ||
        token.includes('technicalexception') ||
        token.includes('technical_exception') ||
        token.includes('technical-exception') ||
        token.includes('technical exception') ||
        token.includes('technicalmarker') ||
        token.includes('technical_marker') ||
        token.includes('technical-marker') ||
        token.includes('technical marker') ||
        token.includes('backendfailure') ||
        token.includes('backend_failure') ||
        token.includes('backend-failure') ||
        token.includes('backend failure') ||
        token.includes('mock') ||
        token.includes('fallback') ||
        token.includes('data_unavailable') ||
        token.includes('dataunavailable') ||
        token.includes('data unavailable') ||
        token.includes('read_failure') ||
        token.includes('readfailure') ||
        token.includes('read failure') ||
        token.includes('read-failure') ||
        token.includes('read_failed') ||
        token.includes('readfailed') ||
        token.includes('read failed') ||
        token.includes('read-failed') ||
        token.includes('read_blocked') ||
        token.includes('readblocked') ||
        token.includes('read blocked') ||
        token.includes('read-blocked') ||
        token.includes('read_unavailable') ||
        token.includes('readunavailable') ||
        token.includes('read unavailable') ||
        token.includes('read-unavailable') ||
        token.includes('read_only') ||
        token.includes('read_only_mode') ||
        token.includes('read only') ||
        token.includes('read only mode') ||
        token.includes('read-only') ||
        token.includes('read-only-mode') ||
        token.includes('readonly') ||
        token.includes('readonlymode') ||
        token.includes('unimplemented') ||
        token.includes('not_implemented') ||
        token.includes('not supported') ||
        token.includes('not_supported') ||
        token.includes('unsupported') ||
        token.includes('not_connected') ||
        token.includes('not-connected') ||
        token.includes('not connected') ||
        token.includes('notconnected') ||
        token.includes('route_unavailable') ||
        token.includes('route-unavailable') ||
        token.includes('route unavailable') ||
        token.includes('routeunavailable') ||
        token.includes('action_blocked') ||
        token.includes('actionblocked') ||
        token.includes('action blocked') ||
        token.includes('action-blocked') ||
        token.includes('fail_closed') ||
        token.includes('failclosed') ||
        token.includes('fail closed') ||
        token.includes('fail-closed') ||
        token.includes('payment_backend_blocked') ||
        token.includes('paymentbackendblocked') ||
        token.includes('payment backend blocked') ||
        token.includes('payment-backend-blocked') ||
        token.includes('payment_status_unconfirmed') ||
        token.includes('paymentstatusunconfirmed') ||
        token.includes('payment status unconfirmed') ||
        token.includes('payment-status-unconfirmed') ||
        token === 'unconfirmed' ||
        token.includes('write_blocked') ||
        token.includes('writeblocked') ||
        token.includes('write blocked') ||
        token.includes('write-blocked') ||
        token.includes('backend_blocked') ||
        token.includes('backendblocked') ||
        token.includes('backend blocked') ||
        token.includes('backend-blocked') ||
        token === 'blocked'
      )
    },
    isLocalLotteryActiveMarker(value) {
      const token = this.lotteryMarkerToken(value)
      return value === true ||
        value === 1 ||
        ['true', '1', 'yes', 'on'].includes(token) ||
        this.isLocalLotteryUnavailableToken(value)
    },
    isLocalLotteryMarkerFlagKey(key) {
      return [
        'mock',
        'mockfallback',
        'mock_fallback',
        'stub',
        'fallback',
        'fallbackused',
        'fallback_used',
        'dataunavailable',
        'data_unavailable',
        'readfailure',
        'read_failure',
        'readfailed',
        'read_failed',
        'readblocked',
        'read_blocked',
        'readunavailable',
        'read_unavailable',
        'readonly',
        'readonlymode',
        'read_only',
        'read_only_mode',
        'readonlyaction',
        'read_only_action',
        'mockmode',
        'mock_mode',
        'unimplemented',
        'notimplemented',
        'not_implemented',
        'notsupported',
        'not_supported',
        'unsupported',
        'blocked',
        'notconnected',
        'not_connected',
        'routeunavailable',
        'route_unavailable',
        'backendblocked',
        'backend_blocked',
        'failclosed',
        'fail_closed',
        'paymentbackendblocked',
        'payment_backend_blocked',
        'paymentstatusunconfirmed',
        'payment_status_unconfirmed',
        'actionblocked',
        'action_blocked',
        'writeblocked',
        'write_blocked',
        'technicalerror',
        'technical_error',
        'technicalexception',
        'technical_exception',
        'technicalmarker',
        'technical_marker',
        'backendfailure',
        'backend_failure',
        'failed'
      ].includes(this.lotteryMarkerToken(key))
    },
    isLocalLotteryMarkerTextKey(key) {
      return [
        'status',
        'state',
        'result',
        'code',
        'errorcode',
        'launchstatus',
        'forwardstatus',
        'msg',
        'message',
        'reason',
        'errormsg',
        'errormessage'
      ].includes(this.lotteryMarkerToken(key))
    },
    isLocalLotteryMarkerMessageKey(key) {
      return [
        'msg',
        'message',
        'reason',
        'errormsg',
        'errormessage'
      ].includes(this.lotteryMarkerToken(key))
    },
    hasLocalLotteryReadableContent(data) {
      const body = this.responseBody(data)
      if (this['pickList'](data, [
        'allLotteryList',
        'lotteryList',
        'list',
        'records',
        'dataList',
        'historyLotteryInfoList',
        'betList',
        'items',
        'pageList'
      ]).length) return true
      return [
        'dateStr',
        'now',
        'time',
        'currIssueNo',
        'issueNo',
        'currBetEndTime',
        'betEndTime',
        'currLotteryTime',
        'endTime'
      ].some(key => body[key] !== undefined && body[key] !== null && body[key] !== '')
    },
    hasLocalLotteryOkMarker(data) {
      return [data, this.responseBody(data)].some((body) => {
        if (!body || typeof body !== 'object') return false
        return body.success === true ||
          ['status', 'state', 'result', 'code', 'errorCode'].some((key) => {
            const token = this.lotteryMarkerToken(body[key])
            return token === 'ok' || token === 'success' || token === '0' || token === '200'
          })
      })
    },
    hasLocalLotteryBlockedMarker(payload, depth = 0, seen = [], options = {}) {
      if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
      seen.push(payload)
      if (Array.isArray(payload)) {
        return payload.some(item => this.hasLocalLotteryBlockedMarker(item, depth + 1, seen, options))
      }
      return Object.keys(payload).some(key => {
        const value = payload[key]
        const keyToken = this.lotteryMarkerToken(key)
        if ((keyToken === 'paymentstatus' || keyToken === 'payment_status') && this.isLocalLotteryUnavailableToken(value)) return true
        if (this.isLocalLotteryMarkerFlagKey(key) && this.isLocalLotteryActiveMarker(value)) return true
        if (this.isLocalLotteryUnavailableToken(key) && ['true', '1', 'yes', 'on'].includes(this.lotteryMarkerToken(value))) return true
        if (value && typeof value === 'object') return this.hasLocalLotteryBlockedMarker(value, depth + 1, seen, options)
        if (!this.isLocalLotteryMarkerTextKey(key)) return false
        if (!this.isLocalLotteryUnavailableToken(value)) return false
        return !(options.allowMetadataMessages &&
          this.isLocalLotteryMarkerMessageKey(key) &&
          !this.isLocalLotteryTechnicalFailureMessage(value))
      })
    },
    isLotteryOk(data) {
      return isLotteryOkResponse(data) && !this.hasLocalLotteryBlockedMarker(data)
    },
    isLotteryReadable(data) {
      const hasReadableContent = this.hasLocalLotteryReadableContent(data)
      if (this.hasLocalLotteryBlockedMarker(data, 0, [], {
        allowMetadataMessages: hasReadableContent
      })) return false
      return isLotteryReadableResponse(data) ||
        (hasReadableContent && this.hasLocalLotteryOkMarker(data))
    },
    isLotteryNeedLogin(data) {
      return isLotteryNeedLoginResponse(data)
    },
    rememberReadOnlyQuery(data) {
      this.readOnlyQuery = isLotteryReadOnlyQueryResponse(data)
    },
    isLocalLotteryTechnicalFailureMessage(value) {
      const message = String(value == null ? '' : value).trim()
      const token = message.toLowerCase()
      return !!token && (
        token.includes('技术错误') ||
        token.includes('技术异常') ||
        token.includes('technical error') ||
        token.includes('technical_error') ||
        token.includes('technical-error') ||
        token.includes('technical exception') ||
        token.includes('technical_exception') ||
        token.includes('technical-exception') ||
        /request failed/i.test(message) ||
        /axios(?:error)?/i.test(message) ||
        /\b(?:typeerror|referenceerror|syntaxerror|rangeerror|urierror)\b/i.test(message) ||
        /\b(?:econn[a-z_]*|enotfound|etimedout|eai_again|socket hang up)\b/i.test(message) ||
        /\b(?:java\.|sql(?:exception)?|select\s+.+\s+from|insert\s+into|update\s+.+\s+set|delete\s+from)\b/i.test(message) ||
        /\bat\s+[\w.$<>]+(?:\s|\()/i.test(message)
      )
    },
    lotteryFailureMessage(data, fallback = this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.', rawMessage = null) {
      const safeFallback = this.isLocalLotteryTechnicalFailureMessage(fallback)
        ? (this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.')
        : fallback
      const message = rawMessage == null ? lotteryResponseMessage(data, safeFallback) : rawMessage
      return this.isLocalLotteryTechnicalFailureMessage(message)
        ? safeFallback
        : message || safeFallback
    },
    handleLotteryUnavailable(data, fallback = this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.') {
      this.rememberReadOnlyQuery(data)
      if (this.isLotteryNeedLogin(data)) {
        this.showPopup3 = true
        return
      }
      const responseMessage = lotteryResponseMessage(data, fallback)
      const message = this.lotteryFailureMessage(data, fallback, responseMessage)
      if (message && this.$toast) {
        this.$toast({ message, icon: 'fail' })
      }
    },
    lotteryEntryEnvelope(entry = {}) {
      const status = isLaunchUnavailableToken(entry.status)
        ? entry.status
        : isLaunchUnavailableToken(entry.lotteryType)
          ? entry.lotteryType
          : 'fail'
      return {
        status,
        content: entry
      }
    },
    isUnavailableLotteryEntry(entry) {
      const item = entry && typeof entry === 'object'
        ? entry
        : { lotteryType: entry }
      if (!item.lotteryType) return true
      if (item.success === false || String(item.success).trim().toLowerCase() === 'false') return true
      if (isLaunchUnavailableToken(item.success)) return true
      const markerValues = [
        item.status,
        item.state,
        item.result,
        item.code,
        item.errorCode,
        item.launchStatus,
        item.forwardStatus,
        item.lotteryType,
        item.lotteryName,
        item.mock,
        item.mockMode,
        item.mock_mode,
        item.mockFallback,
        item.mock_fallback,
        item.stub,
        item.fallback,
        item.fallbackUsed,
        item.fallback_used,
        item.dataUnavailable,
        item.data_unavailable,
        item.readFailure,
        item.read_failure,
        item.readFailed,
        item.read_failed,
        item.readBlocked,
        item.read_blocked,
        item.readUnavailable,
        item.read_unavailable,
        item.technicalMarker,
        item.technical_marker,
        item.readOnly,
        item.readonly,
        item.read_only,
        item.readOnlyMode,
        item.read_only_mode,
        item.readOnlyQuery,
        item.read_only_query,
        item.writeBlocked,
        item.write_blocked,
        item.notConnected,
        item.not_connected,
        item.routeUnavailable,
        item.route_unavailable,
        item.failClosed,
        item.fail_closed,
        item.unimplemented,
        item.notImplemented,
        item.not_implemented,
        item.notSupported,
        item.not_supported,
        item.unsupported,
        item.blocked,
        item.actionBlocked,
        item.action_blocked,
        item.backendBlocked,
        item.backend_blocked,
        item.backendFailure,
        item.backend_failure,
        item.paymentBackendBlocked,
        item.payment_backend_blocked,
        item.paymentStatusUnconfirmed,
        item.payment_status_unconfirmed,
        item.msg,
        item.message,
        item.reason
      ]
      const needLoginToken = 'need_login'
      if (markerValues.some((value) => String(value == null ? '' : value).toLowerCase().includes(needLoginToken))) {
        return true
      }
      if (markerValues.some((value) => value === true || isLaunchUnavailableToken(value) || this.isLocalLotteryUnavailableToken(value))) {
        return true
      }
      if (this.hasLocalLotteryBlockedMarker(item)) return true
      return !this.isLotteryOk({ status: 'ok', content: item })
    },
    clearLotteryLists() {
      this.lotList = []
      this.lotList2 = []
      this.copyLotList2 = []
    },
    handleLotteryReadListUnavailable(listName, data, fallback = this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.') {
      const currentList = Array.isArray(this[listName]) ? this[listName] : []
      if (!currentList.length) this[listName] = []
      this.handleLotteryUnavailable(data, fallback)
    },
    handleLotteryCatalogUnavailable(data, fallback = this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.') {
      const hasExistingCatalog =
        this.lotList.length ||
        this.lotList2.length ||
        this.copyLotList2.length
      if (!hasExistingCatalog) this.clearLotteryLists()
      this.handleLotteryUnavailable(data, fallback)
    },
    pickList(data, keys = []) {
      const body = this.responseBody(data)
      const names = keys.concat([
        'list',
        'records',
        'dataList',
        'betList',
        'historyLotteryInfoList'
      ])
      const search = (source) => {
        if (!source || typeof source !== 'object') return []
        if (Array.isArray(source)) return source
        for (const key of names) {
          if (Array.isArray(source[key])) return source[key]
        }
        for (const key of ['content', 'payload', 'extra', 'page', 'data', 'body']) {
          const list = search(source[key])
          if (list.length) return list
        }
        return []
      }
      return this.safeList(search(body))
    },
    isCryptoLottery(type) {
      return isCryptoLotteryType(type)
    },
    filterPlayableLotteryEntries(list) {
      if (typeof filterPlayableLotteryCatalogEntries === 'function') {
        return filterPlayableLotteryCatalogEntries(list)
      }
      return this.safeList(list).filter(item => !this.isUnavailableLotteryEntry(item))
    },
    normalizeLotteryItem(item = {}) {
      const lotteryType = this.firstValue(
        item.lotteryType,
        item.type,
        item.category,
        item.gameType,
        item.gameCode,
        item.lottery_type,
        item.game_type
      )
      const frequencyValue = this.firstValue(
        item.freqType,
        item.frequencyType,
        item.openFrequency,
        item.freq_type,
        item.frequency_type,
        item.open_frequency
      )
      const normalizedFrequency = String(frequencyValue == null ? '' : frequencyValue).trim().toUpperCase()
      const freqType = {
        HIGH: 'H',
        HIGH_FREQUENCY: 'H',
        'HIGH-FREQUENCY': 'H',
        FAST: 'H',
        LOW: 'L',
        LOW_FREQUENCY: 'L',
        'LOW-FREQUENCY': 'L',
        NORMAL: 'L',
        DAILY: 'L'
      }[normalizedFrequency] || normalizedFrequency
      const currBetEndTime = this.firstValue(
        item.currBetEndTime,
        item.betEndTime,
        item.currLotteryTime,
        item.endTime
      )
      const endTime = new Date(currBetEndTime).getTime()
      return {
        ...item,
        lotteryType,
        freqType,
        lotteryName: this.firstValue(item.lotteryName, item.name, item.gameName),
        currIssueNo: this.firstValue(
          item.currIssueNo,
          item.currentIssueNo,
          item.issueNo,
          item.issue_no
        ),
        currBetEndTime: Number.isNaN(endTime) ? null : endTime,
        countdown: item.countdown || '00:00'
      }
    },
    normalizeDrawItem(item = {}) {
      return {
        ...item,
        lotteryType: this.firstValue(
          item.lotteryType,
          item.type,
          item.gameCode,
          item.lottery_type
        ),
        lotteryName: this.firstValue(
          item.lotteryName,
          item.name,
          item.gameName,
          item.lottery_name
        ),
        issueNo: this.firstValue(item.issueNo, item.currIssueNo, item.issue_no),
        lotteryResult: this.firstValue(
          item.lotteryResult,
          item.drawingResult,
          item.openCode,
          item.open_code,
          item.result,
          item.lottery_num
        ),
        openResultTime: this.firstValue(
          item.openResultTime,
          item.lotteryTime,
          item.drawTime,
          item.draw_time,
          item.createDate,
          item.create_date
        ),
        resultBasedOn: this.firstValue(item.resultBasedOn, item.result_based_on)
      }
    },
    normalizeWinner(item = {}) {
      return {
        ...item,
        userName: this.firstValue(item.userName, item.account, item.nickName, '--'),
        gameName: this.firstValue(item.gameName, item.lotteryName, item.gameCode, '--'),
        amount: this.safeNumber(item.amount || item.winAmount || item.bonusAmount),
        lotteryType: this.firstValue(item.lotteryType, item.gameCode, item.type)
      }
    },
    getIssueNo(item = {}) {
      return this.firstValue(
        item.currIssueNo,
        item.currentIssueNo,
        item.issueNo,
        item.issue_no,
        '--'
      )
    },
    getResultDate(item = {}) {
      const raw = this.firstValue(
        item.openResultTime,
        item.lotteryTime,
        item.drawTime,
        item.createDate
      )
      return raw ? String(raw).slice(0, 10) : '--'
    },
    splitResult(value) {
      if (!value) return []
      if (Array.isArray(value)) return value
      return String(value)
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    },
    parseResult(value) {
      if (!value) return {}
      if (typeof value === 'object') return value
      try {
        return JSON.parse(value)
      } catch (e) {
        return { winning: value }
      }
    },
    getResultBalls(item = {}, key = 'winning') {
      const result = this.parseResult(item.lotteryResult)
      return this.splitResult(result[key])
    },
    hasResultMachine(item = {}) {
      return this.getResultBalls(item, 'machine').length > 0
    },
    goToBin(v) {
      if (!v) return
      openExternalUrl(v)
    },
    // 启动全局定时器
    startGlobalTimer() {
      if (this.globalTimer) {
        clearInterval(this.globalTimer)
      }
      // 立即更新一次
      this.updateAllCountdowns()
      // 每秒更新一次
      this.globalTimer = setInterval(() => {
        if (this.dateStr) {
          this.dateStr += 1000
        }
        this.updateAllCountdowns()
      }, 1000)
    },

    // 更新所有倒计时
    updateAllCountdowns() {
      if (!this.dateStr) return

      // 更新数字彩票列表
      this.lotList.forEach((item) => {
        this.updateSingleCountdown(item)
      })

      // 更新货币彩票列表
      this.lotList2.forEach((item) => {
        this.updateSingleCountdown(item)
      })
    },

    // 更新单个倒计时
    updateSingleCountdown(item) {
      if (!item) return
      // 无效数据处理
      if (isNaN(item.currBetEndTime) || !this.dateStr) {
        item.countdown = '00:00'
        return
      }

      const endTime = item.currBetEndTime
      const currentTime = this.dateStr
      const countdown = endTime - currentTime

      // 倒计时未结束
      if (countdown > 0) {
        item.countdown = this.formatCountdown(countdown)
        return
      }

      // 倒计时已结束且不在刷新中
      if (countdown <= 0 && !this.refreshing.has(item.lotteryType)) {
        item.countdown = '00:00'
        this.refreshSingleItem(item) // 只刷新当前过期项
      }
    },

    // 只刷新指定的过期项
    async refreshSingleItem(item) {
      if (!item) return
      const { lotteryType } = item
      if (!lotteryType) return
      // 标记为正在刷新
      this.refreshing.set(lotteryType, true)

      try {
        const old = Math.floor(Date.now() / 1000)
        // 1. 先获取最新服务器时间（确保时间准确性）
        await this.GetServerDateTime()
        // 2. 只获取当前彩票类型的最新期数信息
        const result = await FreshIssueInfo({ lotteryType })
        const olds = Math.floor(Date.now() / 1000)
        this.hsTime2 = olds - old
        // 3. 验证返回数据并更新
        if (this.isLotteryOk(result)) {
          const content = this.responseBody(result)
          const currBetEndTime = this.firstValue(
            content.currBetEndTime,
            content.betEndTime,
            content.currLotteryTime,
            content.endTime
          )
          const currIssueNo = this.getIssueNo(content)
          const newEndTime = new Date(currBetEndTime).getTime()

          if (!isNaN(newEndTime)) {
            // 更新当前项的结束时间和期号
            item.currBetEndTime = newEndTime
            item.currIssueNo = currIssueNo // 同步更新期号
            // 立即计算新的倒计时
            this.updateSingleCountdown(item)
          }
        } else {
          this.handleLotteryUnavailable(result)
        }
      } catch (error) {
        this.hsTime2 = 0
      } finally {
        // 无论成功失败，都移除刷新标记
        this.refreshing.delete(lotteryType)
      }
    },

    // 格式化倒计时（小时为00时不显示，有值时显示）
    // 格式化倒计时（小时为00时不显示，有值时显示；1分钟时从59秒开始倒计时）
    formatCountdown(ms) {
      const totalSeconds = Math.floor(ms / 1000) // 总秒数（向下取整，避免毫秒导致的误差）
      const days = Math.floor(totalSeconds / 86400)
      const hours = Math.floor((totalSeconds % 86400) / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60 // 修正：直接取余，无需额外加减（totalSeconds已经是向下取整的总秒数）

      const parts = []

      // 处理天数
      if (days > 0) {
        parts.push(`${days}d`)
      }

      // 处理小时（只有当小时大于0时才显示，且补零为两位）
      if (hours > 0) {
        parts.push(hours.toString().padStart(2, '0'))
      }

      // 处理分钟（始终显示，补零为两位）
      parts.push(minutes.toString().padStart(2, '0'))

      // 处理秒数（始终显示，补零为两位；1分钟时自然显示59秒）
      parts.push(seconds.toString().padStart(2, '0'))

      return parts.join(':')
    },

    // 获取服务器时间
    async GetServerDateTime() {
      try {
        const data = await GetServerDateTime()
        const content = this.responseBody(data)
        const timeStr = this.firstValue(content.dateStr, content.now, content.time)
        const newDateStr =
          typeof timeStr === 'number' ? timeStr : new Date(timeStr).getTime()
        if (!isNaN(newDateStr)) {
          this.dateStr = newDateStr
        } else if (!this.dateStr) {
          this.dateStr = Date.now()
        }
      } catch (error) {
        if (!this.dateStr) {
          this.dateStr = Date.now()
        }
      }
    },

    // 其他业务方法
    getLotC(i) {
      this.selectLotIndex = i
      this.lotList2 = filterLotteryByTab(this.copyLotList2, i)
    },

    getToalMout() {
      return this.$formatNumberWithCommas(
        this.pList.reduce((sum, item) => sum + this.safeNumber(item.amount), 0) *
          878
      )
    },

    startScroll() {
      this.timer2 = setInterval(() => {
        this.scrollTop--
        if (Math.abs(this.scrollTop) >= this.pList.length * this.itemHeight) {
          this.scrollTop = 0
        }
      }, 45)
    },

    stopScroll() {
      clearInterval(this.timer2)
      this.timer2 = null
    },

    getFixedAvatarIndex(item, index) {
      const uniqueKey = item.id || index
      return uniqueKey % 8
    },

    async GetHomeWinningLottoList() {
      try {
        const data = await GetHomeWinningLottoList()
        this.rememberReadOnlyQuery(data)
        if (this.isLotteryOk(data)) {
          this.pList = this.pickList(data, [
            'dataList',
            'list',
            'betList',
            'records'
          ]).map(this.normalizeWinner)
        } else {
          this.handleLotteryReadListUnavailable('pList', data)
        }
      } catch (error) {
        this.handleLotteryReadListUnavailable('pList', error)
      }
    },

    getMon(i) {
      return lotteryJackpotMillion(i || {})
    },

    jackpotText(i) {
      const million = this.getMon(i || {})
      if (million === null || million === undefined) return '--'
      return `${this.getCurrency} ${this.$formatNumberWithCommas(million)} ${this.$lang.common_txt170}`
    },

    goToTyepe(v) {
      v = v || {}
      if (!safeGetStorageItem(getLocalStorage(), 'token')) {
        this.showPopup3 = true
        return
      }
      if (!v.lotteryType || this.isUnavailableLotteryEntry(v)) {
        this.handleLotteryUnavailable(
          this.lotteryEntryEnvelope(v),
          this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.'
        )
        return
      }
      this.$jumpTo('/lotteryDetail', {
        lotteryType: v.lotteryType,
        lotteryName: v.gameName
      })
    },

    goToDetail3(v, v2) {
      const entry = v && typeof v === 'object'
        ? v
        : { lotteryType: v, lotteryName: v2 }
      if (this.isUnavailableLotteryEntry(entry)) {
        this.handleLotteryUnavailable(
          this.lotteryEntryEnvelope(entry),
          this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.'
        )
        return
      }
      this.$jumpTo('/latestResults', {
        lotteryType: entry.lotteryType,
        lotteryName: entry.lotteryName,
        isFrom: '1'
      })
    },

    // 单国:开奖记录改走与国家/币种无关的通用接口 GetLotteryLatestResults
    // (prod 实证 getBRDrawHistory/getNGNDrawHistory/getLotteryLatestResults 三端点返回完全一致)。
    // 原 GetNGNDrawHistory 方法(填 lastList)在本页无调用方,随他国接口一并移除。
    async GetDrawHistory() {
      try {
        const data = await GetLotteryLatestResults()
        this.rememberReadOnlyQuery(data)
        if (this.isLotteryOk(data) || this.isLotteryReadable(data)) {
          this.lotResultList = this.pickList(data, [
            'list',
            'historyLotteryInfoList',
            'records'
          ]).map(this.normalizeDrawItem)
        } else {
          this.handleLotteryReadListUnavailable('lotResultList', data)
        }
      } catch (error) {
        this.handleLotteryReadListUnavailable('lotResultList', error)
      }
    },

    goToDetail(v, v2) {
      const entry = v && typeof v === 'object'
        ? v
        : { lotteryType: v, lotteryName: v2 }
      if (!safeGetStorageItem(getLocalStorage(), 'token')) {
        this.showPopup3 = true
      } else if (this.isUnavailableLotteryEntry(entry)) {
        this.handleLotteryUnavailable(
          this.lotteryEntryEnvelope(entry),
          this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.'
        )
      } else {
        this.$jumpTo('/lotteryDetail', {
          lotteryType: entry.lotteryType,
          lotteryName: entry.lotteryName
        })
      }
    },

    getSelectTab(i) {
      this.SelectiTab = i
      if ([1, 2, 3].includes(i)) {
        this.$toast({ message: this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.', icon: 'fail' })
      }
    },

    async MainInit() {
      try {
        const data = await MainInit()
        this.rememberReadOnlyQuery(data)
        if (this.isLotteryOk(data) || this.isLotteryReadable(data)) {
          const allLotteryList = this.filterPlayableLotteryEntries(this.pickList(data, [
            'allLotteryList',
            'lotteryList',
            'list',
            'records'
          ]).map(this.normalizeLotteryItem))
          // 处理数字彩票列表
          this.lotList = allLotteryList
            .filter((i) => i.freqType === 'L')

          // 处理货币彩票列表
          this.lotList2 = allLotteryList
            .filter((i) => i.freqType === 'H')

          this.copyLotList2 = [...this.lotList2]
          this.updateAllCountdowns()
        } else {
          this.handleLotteryCatalogUnavailable(data)
        }
      } catch (error) {
        this.handleLotteryCatalogUnavailable(error)
      }
    },

    goToHistory(v) {
      if (this.isUnavailableLotteryEntry(v)) {
        this.handleLotteryUnavailable(
          this.lotteryEntryEnvelope(v),
          this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.'
        )
        return
      }
      this.$jumpTo('/latestResults', {
        lotteryType: v.lotteryType,
        lotteryName: v.lotteryName
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding-bottom: 16%;
}

.lottery-tab {
  width: 93%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  background: @cont-bg;
  border-radius: 13px;
  padding: 3px 10px;
}
.lottery-tab--i {
  width: 22%;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 0;
}
.select-active {
  background: @brand; /* 彩种 Tab 激活=火焰橙 */
}
.lottery-tab2 {
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  color: @title-color;
}
.lottery-tab2--i {
  width: 14.3%;
  text-align: center;
  padding: 8px 0;
  border-bottom: 1px solid #464a4b;
  font-weight: bold;
}
.select-active2 {
  background: url(../../assets/img/lottery/select-day.png) no-repeat;
  background-size: 100% 100%;
  height: 100%;
  border-bottom: none;
  color: #ffffff;
}
.lottery-tab2--c {
  padding: 10px;
}
.lottery-tab2--bg {
  position: relative;
  width: 100%;
  border-radius: 13px;
}
.lottery-tab2--i1 {
  position: absolute;
  top: 15px;
  left: 20px;
  font-size: var(--vk-fs-15);
  font-weight: bold;
}
.lottery-tab2--i2-x {
  position: absolute;
  top: 70px;
  left: 170px;
  color: #ffeb00;
  font-size: var(--vk-fs-15);
  font-weight: bold;
}
.lottery-tab2--i3 {
  position: absolute;
  background: #232626;
  top: 40px;
  left: 20px;
  border-radius: 8px 15px 15px 0;
  padding: 3px 10px;
  z-index: 2;
  font-size: var(--vk-fs-2xs);
}
.lottery-tab2--i4 {
  background: #f7d827;
  font-weight: bold;
  border-radius: 7px;
  padding: 9px 0;
  font-size: var(--vk-fs-15);
  color: #000000;
  width: 115px;
  text-align: center;
}
.lottery-tab2--i5 {
  position: absolute;
  background: #232626;
  top: 40px;
  left: 145px;
  border-radius: 8px 15px 15px 0;
  padding: 3px 10px;
  z-index: 2;
  font-size: var(--vk-fs-2xs);
}
.lottery-tab2--i6 {
  position: absolute;
  bottom: 55px;
  left: 20px;
}
.lottery-tab2--i7 {
  position: absolute;
  left: 20px;
  bottom: 18px;
  p {
    background: url('../../assets/img/lottery/select-q.png') no-repeat;
    background-size: 100% 100%;
    width: 32px;
    height: 32px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 13px;
    font-weight: bold;
  }
}
.lottery-tab2--i8 {
  position: absolute;
  top: 18px;
  width: 90px;
  left: 30px;
}
.lottery2-tab2--bg {
  position: relative;
  width: 92%;
  margin: 0 auto;
}
.lottery2-tab2--i1 {
  position: absolute;
  top: 19px;
  left: 20px;
  font-size: var(--vk-fs-2xl);
  font-weight: bold;
  width: 145px;
  line-height: 32px;
}
.lottery2-tab2--i2 {
  position: absolute;
  background: url(../../assets/img/lottery/lz2.png);
  font-weight: bold;
  border-radius: 7px;
  top: 110px;
  left: 20px;
  padding: 12px 0;
  font-size: var(--vk-fs-15);
  width: 135px;
  text-align: center;
}
.lottery2-tab2--i4 {
  position: absolute;
  background: #f7d827;
  font-weight: bold;
  border-radius: 7px;
  top: 165px;
  left: 20px;
  padding: 12px 0;
  font-size: var(--vk-fs-15);
  width: 135px;
  color: #000000;
  text-align: center;
}
.lottery2-tab2--i6 {
  position: absolute;
  color: @title-color;
  bottom: 148px;
  left: 20px;
  font-weight: bold;
}
.lottery2-tab2--i7 {
  position: absolute;
  left: 20px;
  bottom: 97px;
  p {
    background: url('../../assets/img/lottery/select-q.png') no-repeat;
    background-size: 100% 100%;
    width: 40px;
    height: 40px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 13px;
    font-size: var(--vk-fs-15);
    font-weight: bold;
  }
}
.lottery2-tab2--i8 {
  position: absolute;
  right: 15px;
  top: 40px;
  width: 140px;
}
.lottery2-tab2--i9 {
  position: absolute;
  width: 97%;
  height: 1px;
  bottom: 83px;
  background: #4e5456;
  left: 5px;
}
.custom-button-xg {
  width: 89%;
  position: absolute;
  bottom: 23px;
  left: 20px;
  box-shadow: none;
}
.img-0 {
  width: 50px;
  height: 30px;
}
.img-1 {
  width: 60px;
  height: 30px;
}
.img-2 {
  width: 60px;
  height: 30px;
}
.img-3 {
  width: 30px;
  height: 30px;
}
.jack-bg {
  background: url(../../assets/img/lottery/lottHis.png) no-repeat;
  background-size: 100% 100%;
  width: 93%;
  margin: 0 auto;
  border-radius: 13px;
  height: 400px;
}
.lot-qbg {
  background: url('../../assets/img/lottery/select-q.png') no-repeat;
  background-size: 100% 100%;
  width: 25px;
  height: 25px;
  color: #000000;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
}
.select-Men {
  background: var(--vk-brand) !important; /* 激活=火焰橙(铁律①,去蓝) */
  color: #ffffff !important;
  border-bottom: 1px solid var(--vk-brand) !important;
}
.content-line {
  margin: 15px auto;
  width: 100%;
  height: 1px;
  background: #a9aeb7;
  opacity: 0.7;
}
.lot-reslut {
  background: #f9f9f9;
  border-radius: 10px;
  padding: 10px 10px;
  box-shadow: -2px 5px 10px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
}
.lot-ball {
  background: url('../../assets/img/lottery/select-q.png') no-repeat;
  border-radius: 20px;
  background-size: 100% 100%;
  width: 32px;
  height: 32px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  font-weight: bold;
  font-size: var(--vk-fs-xs);
  margin-bottom: 5px;
}
.lot_hh {
  background: url(../../assets/img/lottery/hua_s.png) no-repeat;
  width: 32px;
  height: 32px;
  background-size: 100% 100%;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
.scroll-list {
  transition: transform 0.5s linear;
}
.active-lotL {
  background: @brand !important; /* 彩票左侧列表激活=火焰橙 */
}
</style>
